/**
 * 门店与员工接口
 * 对应 server/src/modules/stores、server/src/modules/staff
 */
import { http } from "@/lib/api/http";
import type { Employee, Store } from "@/lib/api/types";

export const storesApi = {
  list: () => http.get<Store[]>("/stores"),

  create: (input: {
    code: string;
    name: string;
    mobile?: string;
    address?: string;
    timezone?: string;
  }) => http.post<Store>("/stores", { body: input }),

  update: (
    storeId: string,
    input: Partial<{
      code: string;
      name: string;
      mobile: string;
      address: string;
      timezone: string;
      status: "active" | "inactive" | "closed";
    }>,
  ) => http.patch<Store>(`/stores/${storeId}`, { body: input }),
};

export const staffApi = {
  /** 不传 storeId 时返回商户下全部员工 */
  list: (params?: { storeId?: string }) =>
    http.get<Employee[]>("/staff", { query: params }),

  create: (input: {
    employeeNo: string;
    name: string;
    mobile?: string;
    title?: string;
    joinedAt?: string;
    /** 月底薪，十进制字符串。传 '0.00' 表示没有底薪 */
    baseSalary?: string;
    /** 员工任职门店，至少一家 */
    storeIds: string[];
  }) => http.post<Employee>("/staff", { body: input }),

  update: (
    staffId: string,
    input: Partial<{
      employeeNo: string;
      name: string;
      mobile: string;
      title: string;
      joinedAt: string;
      /** 月底薪。要清掉已有底薪必须显式传 '0.00'，不传是"这一项不改" */
      baseSalary: string;
      storeIds: string[];
      status: "active" | "inactive" | "left";
    }>,
  ) => http.patch<Employee>(`/staff/${staffId}`, { body: input }),

  assignRoles: (
    staffId: string,
    input: {
      roleCodes: string[];
      /**
       * **只在第一次创建登录账号时有用**。账号已存在时服务端会忽略它——
       * 想给已有账号换密码要用 `resetPassword`。
       */
      initialPassword?: string;
    },
  ) => http.patch<Employee>(`/staff/${staffId}/roles`, { body: input }),

  /**
   * 店主帮员工重置登录密码。门店里没有邮箱找回，员工忘了密码只能找店主。
   *
   * **会把该员工已有的登录态全部踢掉**（服务端自增 credentialVersion）：
   * 忘记密码常常伴随手机丢失或离职交接，重置完旧手机还登着就没有意义。
   */
  resetPassword: (staffId: string, newPassword: string) =>
    http.post<{ reset: true }>(`/staff/${staffId}/reset-password`, {
      body: { newPassword },
    }),
};
